<template>
  <div class="full-width align-center">
    <ProgressSpinner :aria-label="props.label ? props.label : 'Loading'"/>
  </div>
</template>

<script setup>
const props = defineProps({
  label: String
})
</script>